import { transport } from 'config/transport';

export function callApiExportPhieuThuThuDauNam(classId, studentIds) {
    return transport.get(`/mamnon/thuhocsinh/thudaunam/exportPhieuThuPdf/${classId}`, { responseType: 'blob', params: { studentIds } });
}
